export default __webpack_public_path__ + "static/media/note-gray.cb39198f.svg";